<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Identification Documents</h1>
                </div>

                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>    
            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('userForm')">
                <label class="pb-3" for="">Are you eligible to work in the United States?</label>
                <el-form-item class="no-scroll" prop="eligible_to_work_in_usa" :required="true">
                    <el-select class="eligibility-select" style="width: 100%"
                        v-model="formsData.userForm.eligible_to_work_in_usa.value" placeholder="Please select" popper-class="normal-select">
                        <el-option label="Yes" :value="1"></el-option>
                        <el-option label="No" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <label class="pb-3" for="">Do you or will you require sponsorship for an employment via (should be visa) or for authorization to work in the United States?</label>
                <el-form-item class="no-scroll" prop="require_sponsorship" :required="true">
                    <el-select class="eligibility-select" style="width: 100%"
                        v-model="formsData.userForm.require_sponsorship.value" placeholder="Please select" popper-class="normal-select">
                        <el-option label="Yes" :value="1"></el-option>
                        <el-option label="No" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="button_submit button_submit mb0">
                    <el-button class="submit" type="blue" @click="goNext('userForm')"
                        :disabled="formsData.userForm.disabled">
                        Next 
                        <!-- <i class="el-icon-right"></i> -->
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles" v-if="isAustralia">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, inject } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";

import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import { ElMessageBox } from "@/components/Vendor/Element";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon
    },
    setup() {
        
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject(["setPageClassGlobal"]);
        const userData = $store.getters.GET_USER_DATA;
        const isAustralia = isAustraliaRegion();

        const formsDataArray = {
            userForm: {
                ref: null,
                eligible_to_work_in_usa: {
                    value: userData.settings.eligibleToWorkInUsa || 0,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "eligibleToWorkInUsa",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
                require_sponsorship: {
                    value: userData.settings.requireSponsorship || 0,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "requireSponsorship",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
            },
        };

        const goBack = async() => {
            const back = await $store.dispatch("getAuthPageBack");
            $router.push({
                name: back,
            });  
        };

        const goNext = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            let formValues = getFormValues(formName);
                            if (!formValues.eligible_to_work_in_usa) {
                                formValues = {
                                    ...formValues,
                                    eligible_to_work_in_usa: 0,
                                };
                            }
                            if (!formValues.require_sponsorship) {
                                formValues = {
                                    ...formValues,
                                    require_sponsorship: 0,
                                };
                            }
                            
                            await $store.dispatch("SAVE_USER_DATA", formValues);
                            $router.push({
                                name: 'auth_tax_and_payments',
                            });
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log("error submit!!");
                    return false;
                }
            });
        };

        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    $router.push({
                        name: 'auth_tax_and_payments',
                    })
                } catch (error) {
                    console.log(error);
                }
            })();
          
        }

        onMounted(() => {
            setPageClassGlobal("global_auth_page");
            setFormRefs();
            checkFormValidation("userForm", false);
        });

        const {
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            formsData,
            goBack,
            goNext,
            skip,
            isAustralia
        };
    },
};
</script>